export interface LatLngInterface {
    constructor(lat: number, lng: number): void;
    lat(): number;
    lng(): number;
  }